import React from 'react'
import { LoadingSpinner } from '@atoms'

type LoadingWrapperProps = {
  loading: boolean
  children: React.ReactNode
}

const LoadingWrapper = ({ loading, children }: LoadingWrapperProps) => {
  return (
    <div 
      className="tw:relative tw:group" 
      data-loading={loading || null} 
      data-testid={loading ? 'loading-wrapper-active' : 'loading-wrapper-inactive'}
    >
      <div className="tw:absolute tw:z-50	tw:hidden tw:group-data-loading:flex tw:inset-0 tw:w-full tw:h-full tw:p-4 tw:justify-center">
        <LoadingSpinner />
      </div>
      <div className="tw:transition-opacity tw:group-data-loading:opacity-30 tw:group-data-loading:select-none">
        {children}
      </div>
    </div>
  )
}

export default LoadingWrapper
